// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionStyle: 'style2',
    //suggestionStyle2MainContainerSelector: '#shopify-section-header',
    suggestionMobileStyle: 'style2',
  }
};

//Set theme search mode to product only
window.theme.searchMode = 'product';

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  SearchInput.prototype.beforeBindEvents = function (id) {
    var id = this.id;
    if (id == Class.searchBox + '-0') {
      this.$element = removeThemeSearchEvent();
      this.instantSearchResult.$searchInputElement = this.$element;
    }
    recallThemeOnPageShowEvent();

    if (Utils.InstantSearch.isFullWidthMobile()) {
      jQ(id).removeAttr('autofocus');
      if (jQ(id).is(':focus')) {
        jQ(id).blur();
      }
    }
  };

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot redirect to search page when pressing enter
    jQ('.boost-pfs-search-box').on('keypress', function(event) {	
      if (event.keyCode == 13) {	
        jQ(this).parents('form').submit();	
      }	
    })
  }

  function removeThemeSearchEvent() {
    // Remove all events
    if (jQ('[name="q"]').length > 0) {
      var cloneSearchBar = jQ('[name="q"]').first().clone();
      jQ(cloneSearchBar).removeClass('Form__Input').addClass('Search__Input Heading');
      jQ('[name="q"]').first().empty().append(cloneSearchBar);
      if (jQ('#Search').length > 0) {
        if (jQ('#Search').hasClass('Modal--fullScreen')) {
          jQ('#Search').attr("style", "height: 0px !important");
        }
        jQ('#Search .Search__Results').attr("style", "display: none !important");
      }

      // Rebuild click search icon event
      if (jQ('[data-action="toggle-search"]').length > 0) {
        jQ('[data-action="toggle-search"]').on('click', function () {
          setTimeout(function () {
            jQ('[name="q"]').first().focus();
          }, 500);
        })
      }
    }
    // disable page transition
    if (window.theme && window.theme.showPageTransition) {
      window.theme.showPageTransition = false;
    }
    return jQ('[name="q"]').first();
  }

  function recallThemeOnPageShowEvent() {
    // disable page transition
    var pageTransition = document.querySelector('.PageTransition');
    if (pageTransition) {
      pageTransition.style.visibility = 'visible';
      pageTransition.style.opacity = '0';
    }
    // refresh cart
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }

  // Start Boost 211715
  var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    var localeURLPart = "";

    if (hasShopifyRoutes) {
        localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    } else if (elements.indexOf(boostPFSConfig.general.current_locale) > -1) {
        localeURLPart = "/" + boostPFSConfig.general.current_locale;
    }
  
    InstantSearchResultItemProduct.prototype.afterRender = function() {
      if (this.hasOwnProperty('data') && this.data !== null) {
        var data = this.data;
        quickUrl = localeURLPart + '/products/' + this.data.handle + '?view=boost-pfs-prod-prices';
        jQ.ajax({
            url: quickUrl,
            success: function(result) {
              // var res = JSON.parse(result)
              console.log({result})
              jQ('[data-id="' + data.id + '"]').find('.boost-pfs-search-suggestion-product-price').addClass('active').html(result);
            }
        });
      }
    }

 //    function buildPrice(data) {
	// 	var html = '';
 //        var onSale = data.compare_at_price_min > data.price_min;
 //        var priceVaries = data.price_min < data.price_max;

	// 		if (onSale) {
	// 			html += '<span class="boost-pfs-search-suggestion-product-sale-price" style="white-space: nowrap;">' + Utils.formatMoney(data.price_min, undefined, true) + '</span>';
	// 			html += '<s style="white-space: nowrap;">' + Utils.formatMoney(data.compare_at_price_min, undefined, true) + '</s> ';
			
	// 		} else {
 //              html += '<span class="boost-pfs-search-suggestion-product-regular-price" style="white-space: nowrap;">' + Utils.formatMoney(data.price_min, '', true) + '</span>';
	// 		}
		
	// 	return html;
	// }
  // End Boost 211715
})();
